/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadFilesVo } from './UploadFilesVo';
import {
    UploadFilesVoFromJSON,
    UploadFilesVoFromJSONTyped,
    UploadFilesVoToJSON,
    UploadFilesVoToJSONTyped,
} from './UploadFilesVo';

/**
 * 
 * @export
 * @interface ResponseListUploadFilesVo
 */
export interface ResponseListUploadFilesVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListUploadFilesVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListUploadFilesVo
     */
    message?: string;
    /**
     * 
     * @type {Array<UploadFilesVo>}
     * @memberof ResponseListUploadFilesVo
     */
    data?: Array<UploadFilesVo>;
}

/**
 * Check if a given object implements the ResponseListUploadFilesVo interface.
 */
export function instanceOfResponseListUploadFilesVo(value: object): value is ResponseListUploadFilesVo {
    return true;
}

export function ResponseListUploadFilesVoFromJSON(json: any): ResponseListUploadFilesVo {
    return ResponseListUploadFilesVoFromJSONTyped(json, false);
}

export function ResponseListUploadFilesVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListUploadFilesVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UploadFilesVoFromJSON)),
    };
}

export function ResponseListUploadFilesVoToJSON(json: any): ResponseListUploadFilesVo {
    return ResponseListUploadFilesVoToJSONTyped(json, false);
}

export function ResponseListUploadFilesVoToJSONTyped(value?: ResponseListUploadFilesVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UploadFilesVoToJSON)),
    };
}

